import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Inbox } from "lucide-react";
import { legislationRequest } from "../lib/legislation";
import type { NotificationInboxResult } from "../lib/notifications";

export function NotificationInboxLink({ workspaceId }: { workspaceId: string | null }) {
  const query = useQuery({
    queryKey: ["notifications", workspaceId, "badge"],
    queryFn: ({ signal }) => legislationRequest<NotificationInboxResult>(`/api/v1/workspaces/${encodeURIComponent(workspaceId!)}/notifications?unread_only=true&limit=1`, {signal}),
    enabled: Boolean(workspaceId),
    refetchInterval: 30_000,
  });
  const unread = query.data?.unread_count_total ?? query.data?.unread_count ?? 0;
  const label = query.error ? "Notifications · unread count unavailable" : query.isLoading ? "Notifications · loading unread count" : unread ? `Notifications · ${unread} unread` : "Notifications";
  return <Link to={`/notifications${workspaceId ? `?workspace_id=${encodeURIComponent(workspaceId)}` : ""}`} aria-label={label} title={label} className="relative inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-stone-700 hover:bg-stone-100">
    <Inbox size={19} aria-hidden="true" />
    {unread > 0 && <span aria-hidden="true" className="absolute -right-1 -top-1 min-w-4 rounded-full bg-action px-1 text-center text-[10px] font-bold leading-4 text-white">{unread > 99 ? "99+" : unread}</span>}
    {query.error && <span aria-hidden="true" className="absolute right-0 top-0 rounded-full bg-amber-100 px-1 text-xs text-amber-900">!</span>}
  </Link>;
}
